<template>
  <div class="container">
    <!-- Modal -->
    <div v-if="this.$store.state.modal.modalListaGlosasPorMes.show" class="in show modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">

          <div class="modal-header">
              <button type="button" class="close" v-on:click="fecharModal()">&times;</button>
              <h1 class="modal-title">Lista de glosas</h1>
          </div>

          <div class="modal-body alert-body icon-acoes btable">

            <section class="loading" v-show="loadingGlosas === true">
                <HalfCircleSpinner
                     :animation-duration="2000"
                     :size="60"
                     :color="'#3c8dbc'"
                />
                <p class="sem-glosas">Procurando glosa...</p>
            </section>

            <b-table v-show="loadingGlosas === false"
              striped hover
              :items="glosas"
              v-if="glosas.length"
              :fields="fieldsGlosas"
              >

              <template v-slot:cell(valor)="data">
                  <money v-model="data.item.valor" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
              </template>

              <template v-slot:cell(arquivo)="data">
                  <a href="javascript:void(0)" v-on:click="downloadArquivo(data.value)" v-if="data.item.arquivo">Download</a>
                  <span v-else> - </span>
              </template>

              <template v-slot:cell(excluir)="data">
                <div class="btn-excluir">
                  <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="excluirGlosa(data.item)"><i class="fa fa-times-circle-o"></i></a>
                  <a href="javascript:void(0)" v-else>Aguarde...</a>
                </div>
              </template>

              <template v-slot:cell(anulado)="data">

                  <div class="btn-anular" v-if="!data.value">
                    <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="anularGlosa(data.item.glosa_id)" title="Anular evidência"><i class="fa fa-times-circle-o"></i></a>
                    <a href="javascript:void(0)" v-else>Aguarde...</a>
                  </div>
                  <div class="btn-desanular" v-else>
                    <a href="javascript:void(0)" v-if="controlerLoadingDelete" v-on:click="desanularGlosa(data.item.glosa_id)" title="Desanular evidência"><i class="fa fa-times-circle-o"></i></b-icon></a>
                    <a href="javascript:void(0)" v-else>Aguarde...</a>
                  </div>

              </template>

            </b-table>
            <div v-else-if="loadingGlosas === null">
              <p class="sem-glosas">Ops... não há glosa por aqui... (-:</p>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" v-on:click="fecharModal()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {HalfCircleSpinner} from 'epic-spinners'
import {Money} from 'v-money'

export default {
  props: ['glosasMesAtual'],
  data () {
    return {
      controlerLoadingDownload: true,
      controlerLoadingDelete: true,
      // controlerLoading: false,
      env: process.env,
      zIndex: 999999,
      form: [],
      glosas: [],
      fieldsGlosas: [
        { key: 'mes.nome', label: 'Mês' },
        { key: 'quantidade', label: 'Quantidade' },
        { key: 'valor', label: 'Valor' },
        { key: 'observacao', label: 'Observações' },
        { key: 'arquivo', label: 'Arquivo' },
        // { key: 'anulado', label: 'Anular' },
        { key: 'excluir', label: 'Excluir' }
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      loadingGlosas: true
    }
  },
  mounted: function () {
    this.getGlosaFiltroAnoContratoMes()
  },
  components: {
    HalfCircleSpinner,
    Money
  },
  watch: {
    glosasMesAtual: function () {
      this.loadingGlosas = true
      this.getGlosaFiltroAnoContratoMes()
    }
  },
  methods: {
    getTimeoutLoadingGlosa: function () {
      setTimeout(() => {
        this.loadingGlosas = null
      }, 7000)
    },
    configuraGlosaAnulada: function () {
      let vm = this
      setTimeout(() => {
        let registrosAnulados = document.querySelectorAll('.btn-desanular')
        registrosAnulados.forEach(item => {
          let elem = item.parentElement.parentElement
          elem.style.textDecoration = 'line-through'
          elem.style.color = '#ccc'
        })
        vm.loadingGlosas = false
      }, 0)
    },
    getGlosaFiltroAnoContratoMes () {
      let vm = this
      if (this.glosasMesAtual.conteudo.length === 0) {
        return
      }

      let formData = new FormData()
      formData.append('ano', this.glosasMesAtual.conteudo.itens.ano)
      formData.append('contrato_id', this.glosasMesAtual.conteudo.itens.contrato_id)
      formData.append('mes_id', this.glosasMesAtual.conteudo.itens.mes.mes_id)

      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/getGlosaFiltroAnoContratoMes`, formData, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.glosas = response.data
        vm.loadingGlosas = false
      })
      .catch(function (error) {
        vm.loadingGlosas = false
        console.log(error)
      })
    },
    excluirGlosa: function (glosa) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingGlosas = true
      glosa['usuario_nome'] = this.$store.state.login.loginUsuario.usuario.name
      glosa['usuario_email'] = this.$store.state.login.loginUsuario.usuario.email
      glosa['glosa_id'] = glosa.id
      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/excluirGlosa`, glosa, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getGlosaFiltroAnoContratoMes()
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    anularGlosa: function (id) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingGlosas = true
      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/anularGlosa`, {
        glosa_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      },
        {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'application/json'
          }
        })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getGlosaFiltroAnoContratoMes()
      })
      .catch(function (error) {
        vm.loadingGlosas = true
        console.log(error)
      })
    },
    desanularGlosa: function (id) {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.loadingGlosas = true
      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/desanularGlosa`, {
        glosa_id: id,
        'usuario_nome': this.$store.state.login.loginUsuario.usuario.name,
        'usuario_email': this.$store.state.login.loginUsuario.usuario.email
      },
        {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'application/json'
          }
        })
      .then(function (response) {
        let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
        vm.$store.commit('setRefreshComponente', refreshComponentes)
        vm.getGlosaFiltroAnoContratoMes()
      })
      .catch(function (error) {
        vm.loadingGlosas = true
        console.log(error)
      })
    },
    downloadArquivo: function (fileName) {
      let vm = this
      let dirBucket = 'glosa'
      this.controlerLoadingDownload = false
      this.$axios.get(`${this.env.STORAGE}/download?dirBucket=${dirBucket}&fileName=${fileName}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        vm.controlerLoadingDownload = true
        // Condição espefifica para acesso não autorizado retornado pelo microsserviço STORAGE
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
          return
        }
        window.open(response.request.responseURL, '_blank')
      })
    },
    confirmarAcao: function () {
      return confirm('Confirma esta ação?')
    },
    fecharModal: function () {
      this.$store.commit('setModalListaGlosasPorMes', {conteudo: [], show: false})
      console.log('fechar')
    }
  }
}
</script>
<style scoped src="../css/modalListarGlosa.css"></style>




// WEBPACK FOOTER //
// ModalListarGlosas.vue?d391c130